module.exports = __webpack_public_path__ + "assets/img/service6.9067ee78.png";